import { Colors, Lightning, Utils } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';
import SeriesInfo from './components/SeriesInfo';
import PaidTitleModal from '../Home/components/UpgradeModal';

export default class Series extends Lightning.Component {
  static _template() {
    return {
      PaidTitleModal: {
        zIndex: 200,
        w: 1920,
        h: 1080,
        rect: true,
        color: Colors('#000000').get(),
        type: PaidTitleModal,
        visible: false,
      },
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Content: {
        x: 120,
        w: 1720,
        type: SeriesInfo,
      },
      ErrorMessage: {
        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
        w: 1920,
        h: 1080,
        rect: true,
        color: Colors('#000000').get(),
        visible: false,
        Logo: {
          // x: 220,
          // y: 215,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 484, 76),
        },
        Title: {
          // y: 490,
          y: 50,
          text: {
            fontSize: 32,
            wordWrapWidth: 620,
            fontFace: 'OpenSans-Regular',
            textAlign: 'center',
            text: "Sorry, can't find that series. We're on it. Try again later. Thanks.",
            lineHeight: 43,
          },
        },
      },
      Column: {
        collision: true,
        x: 120,
        y: 500,
        type: Column,
        plinko: true,
      },
    };
  }

  get _Content() {
    return this.tag('Content');
  }

  get _Column() {
    return this.tag('Column');
  }

  get _ErrorMessage() {
    return this.tag('ErrorMessage');
  }

  set isUndefined(val) {
    return (this._isUndefined = val);
  }

  _active() {
    this._setState('Column');
  }

  $changeSeriesInfo({
    title,
    description,
    category,
    duration,
    cover,
    rating,
    votes,
    contentRating,
  }) {
    const ratingText = `${rating}/10`;
    const categoryText = category.join(' • ');

    const parts = duration.split(':').map((part) => parseInt(part));
    let seconds = 0;
    if (parts.length === 3) {
      // If time format is HH:MM:SS
      seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
    } else if (parts.length === 2) {
      // If time format is MM:SS
      seconds = parts[0] * 60 + parts[1];
    }
    // Modify the duration text
    let hours = parts.length === 3 ? parts[0].toString().padStart(2, '0') : '00';
    let minutes = parts[parts.length - 2].toString().padStart(2, '0');
    let secondsPart = parts[parts.length - 1].toString().padStart(2, '0');

    const durationText =
      seconds >= 3600 ? `${hours}:${minutes}:${secondsPart} | ` : `${minutes}:${secondsPart} | `;

    this.tag('Content.Info').patch({
      Title: { text: { text: title } },
      Informations: {
        DurationAndIcon: {
          Svg: {
            x: seconds > 3600 ? 130 : 90,
            texture: lng.Tools.getSvgTexture(
              Utils.asset('images/movie-info-icons/star.svg'),
              20,
              20
            ),
          },
          text: { text: durationText },
        },
        Rating: {
          x: seconds > 3600 ? 165 : 125,
          text: { text: `IMDB ${ratingText}` },
        },
        Votes: {
          x: seconds > 3600 ? 315 : 275,
          text: { text: `(${votes})` },
        },
        ContentRating: {
          x: seconds > 3600 ? 375 : 330,
          text: { text: `| (${contentRating})` },
        },
      },
      Category: {
        text: { text: categoryText },
      },
      Description: { text: { text: description } },
    });

    this.tag('Content.Cover').patch({
      texture: { src: cover },
    });
  }

  $showPaidTitleModal() {
    (this.tag('PaidTitleModal').visible = true), this._setState('PaidTitleModal');
  }

  $hidePaidTitleModal() {
    this.tag('PaidTitleModal').visible = false;
    this._setState('Column');
  }

  $setIndex(index) {
    this._Column.selectedIndex = index;
  }

  static _states() {
    return [
      class Column extends this {
        _getFocused() {
          return this._Column;
        }
      },
      class PaidTitleModal extends this {
        _getFocused() {
          return this.tag('PaidTitleModal');
        }
      },
    ];
  }
}
